export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_07.7127ce61.jpg";